import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';
import { useSelectIsFeatureEnabled } from 'app/store/featureToggles/selectors';
import { WellKnownFeatureToggleKeys } from 'app/store/featureToggles/FeatureTogglesState';

export default function OutliersHelp() {
    const isLastPriceEnabled = useSelectIsFeatureEnabled(
        WellKnownFeatureToggleKeys.LastPriceEnabled
    );

    return (
        <IconTooltip>
            <div>
                This chart visualizes order performance versus a chosen
                benchmark.
            </div>
            {isLastPriceEnabled ? (
                <div>
                    The X-axis represents P&L, and you can choose from Realized,
                    Unrealized or Total in the settings modal.
                </div>
            ) : (
                <div>The X-axis represents Realized P&L.</div>
            )}
            <div>
                The Y-axis represents the performance of your order against your
                chosen benchmark in bps. You can choose to benchmark to either
                Arrival Price or Adjusted Arrival Pricen(uses the Impact Model)
                in the settings modal.
            </div>
            <div>You scan swap the axes around in the settings modal.</div>
            <div>The size of the bubble relates to order value.</div>
            <div>
                Use the settings modal to choose whether to show a grid with the
                orders, and the position of the grid within the widget.
            </div>
            <div>
                When you hover over a bubble, the orders under the bubble are
                highlighted in the grid.
            </div>
            <div>
                You can select orders by clicking the rows in the grid
                (SHIFT-Click to select multiple rows), or clicking a bubble
                (SHIFT Click for multiple selections, CTRL-Click selects every
                order under the cursor). Selected bubbles are highlighted in
                both the grid and chart.
            </div>
            <div>
                When there is a selection, you can show/hide unselected bubbles
                by clicking the show/hide button in the grid toolbar.
            </div>
            <div>
                Use the zoom button in the chart to view bubbles that may be
                overlapping each other.
            </div>
        </IconTooltip>
    );
}
